<div class="d-flex flex-column align-items-center">
  <img
    class="w-100"
    [src]="src"
  />
</div>
